module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAALlJREFUOE/tlU0OAUEQhV/VxBk4gB0ye8Et/JxBwpyFzCH83ELEXthxAYeYetJ2GNNEJ7OZ3lbVS7/3VboFnpO0WbcIe9emGXqLs9yKRsQr2OGQio3rM8MoPcn2P8GYYwKrhyAwSY+yrgSfEvBDKT1Dt2eZYACF5tEToiuCuauRWFJwyKVssIjYySzmRYCmbx+/qRO4hhecttioKfqfLNuLZS2wDGfZZyUpnXJ1w7cEwkMJ/sD++AXcAdf8k2NGIMqGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-add.png
// module id = V1/z
// module chunks = 1